import { apiRequest } from '../utils/api';

const BASE = '/api/v1/tutor-favorites';

export const fetchFavoriteTutors = () => apiRequest(BASE, { method: 'GET' });

export const fetchFavoriteTutorIds = () =>
  apiRequest(`${BASE}/ids`, { method: 'GET' });

export const favoriteTutor = (tutorProfileId) =>
  apiRequest(`${BASE}/${tutorProfileId}`, { method: 'POST' });

export const unfavoriteTutor = (tutorProfileId) =>
  apiRequest(`${BASE}/${tutorProfileId}`, { method: 'DELETE' });
